import DispatchConstants from '../../constants/DispatchConstants';

const initState = () => ({
  reviews: [],
  averageStarLevel: 0,
  totalNumberOfReviews: 0,
});

const reviewsForListing = (state = initState(), action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case DispatchConstants.REVIEWS_FOR_LISTING_GET_SUCCESS: {
      const { appendToReviews, reviewsForListing } = payload;
      if (appendToReviews) {
        return Object.assign({}, state, { reviews: [...state.reviews, ...reviewsForListing.reviews] });
      }
      return Object.assign({}, state, reviewsForListing);
    }
    case DispatchConstants.REVIEW_RESPONSE_UPDATE_SUCCESS: {
      const newReview = payload.review;
      return Object.assign({}, state, {
        reviews: state.reviews.map((review) => {
          if (review.id === newReview.id) {
            return {
              ...review,
              responseMessage: newReview.responseMessage,
              reviewResponseStatus: newReview.reviewResponseStatus,
              reviewResponseDateIsoString: newReview.reviewResponseDateIsoString,
              reviewResponseId: newReview.reviewResponseId,
            };
          }
          return review;
        }),
      });
    }
    case DispatchConstants.REVIEW_RESPONSE_DELETE_SUCCESS: {
      const { reviewResponseId } = payload;
      return Object.assign({}, state, {
        reviews: state.reviews.map((review) => {
          if (review.reviewResponseId === reviewResponseId) {
            return {
              ...review,
              responseMessage: '',
              reviewResponseStatus: '',
              reviewResponseDateIsoString: '',
              reviewResponseId: '',
            };
          }
          return review;
        }),
      });
    }
    case DispatchConstants.REVIEW_REPORT_SUCCESS:
      return Object.assign({}, state, {
        reviews: state.reviews.map((review) => {
          if (review.id === payload.review.id) {
            return {
              ...review,
              managerReportedStatus: payload.review.managerReportedStatus,
            };
          }
          return review;
        }),
      });
    default:
      return state;
  }
};

export default reviewsForListing;
